// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
const HUB_NAME = 'workflowmessagerelayhub';

// ============= Types =============
export interface SendMessageWorkflowSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  workflowId: string;
  senderId: string;
  message: string;
}

// ============= Main Function =============
/**
 * Sends a message via WorkspaceRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param workflowId The workflow ID
 * @param senderId The ID of the message sender
 * @param message The message content
 * @returns Promise with API response or error
 */
export const sendMessageWorkflowSession = async ({
  invokeHub,
  workflowId,
  senderId,
  message,
}: SendMessageWorkflowSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Sending message in workflow [${workflowId}] via WorkflowMessageRelayHub...`
    );

    if (!workflowId) {
      throw new Error('workflowId is required');
    }
    if (!senderId) {
      throw new Error('senderId is required');
    }
    if (!message) {
      throw new Error('message is required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'SendMessageAsync',
      workflowId,
      senderId,
      message
    );

    console.log(`✅ Message sent successfully in workflow [${workflowId}]`);
    return result;
  } catch (error) {
    console.error(
      `🔴 Error sending message in workflow [${workflowId}] via WorkflowMessageRelayHub:`,
      error
    );
    throw error;
  }
};
